var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('InputTextArea',_vm._b({on:{"input":_vm.onInput},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'InputTextArea',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }